import { createSlice } from "@reduxjs/toolkit";
import { getMsgStatusInOrder } from "../../Helpers/Chat/ChatHelper";
import { changeTimeFormat } from "../../Helpers/Chat/RecentChat";

const initialState = {
    "id" : null,
    "data": {}
}

const stringContainjid = (s, word) => {
    return new RegExp('\\b' + word + '\\b', 'i').test(s);
}

const updateMessageInfo = (time, activeUserId, messageStatus, participants = []) => {
    return participants.map(participant => {
        const { userId, deliveredTime, seenTime, msgStatus } = participant

        if (stringContainjid(activeUserId, userId)) {
            return {
                ...participant,
                ...(messageStatus === 1 && { deliveredTime: (time && deliveredTime === '0000-00-00 00:00:00') ? changeTimeFormat(time) : deliveredTime }),
                ...(messageStatus === 2 && { seenTime: (time && seenTime === '0000-00-00 00:00:00') ? changeTimeFormat(time) : seenTime }),
                msgStatus: getMsgStatusInOrder(msgStatus, messageStatus)
            }
        }
        return participant;
    })
}

const messageInfoData = createSlice({
    name:'messageInfoData',
    initialState,
    reducers:{
        addMessageInfoData: (_state = initialState, payload = {})=>{
            const { payload: { id, data } = {} } = payload
               return {
                ..._state,
                "id": id,
                "data": data
            }
        },
        addMessageInfoUpdate: (_state = initialState, payload = {})=>{
            const { payload: { id, activeUserId, messageStatus = '', time } = {} } = payload
               return {
                ..._state,
                'id': id,
                'data': {
                    ..._state.data,
                    participants: updateMessageInfo(time, activeUserId, messageStatus, _state.data?.participants)
                }
            }
        }
    }    
});

export default messageInfoData.reducer
export const addMessageInfoData = messageInfoData.actions.addMessageInfoData
export const addMessageInfoUpdate = messageInfoData.actions.addMessageInfoUpdate
